// Shopify Storefront API - CORRECTED with MyShopify Domain
// Custom Domains can lose API headers through redirects!

const SHOPIFY_DOMAIN = 'berleto-com.myshopify.com'; // ✅ Use .myshopify.com for API
const SHOPIFY_STOREFRONT_ACCESS_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN || '';
const SHOPIFY_API_VERSION = '2023-10'; // ✅ Use working API version from test

// Product Handle Mapping
export const PRODUCT_HANDLE_MAP = {
  'rush': 'rush',
  'synaptiq': 'synaptiq',
  'vitra': 'vitra'
};

// Create API URL
export const getStorefrontApiUrl = () => {
  return `https://${SHOPIFY_DOMAIN}/api/${SHOPIFY_API_VERSION}/graphql.json`;
};

// Create Headers
export const getStorefrontHeaders = () => {
  return {
    'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    'Content-Type': 'application/json'
  };
};

// Fetch product price - EXACT copy of working test method
export async function fetchProductPrice(productId) {
  const handle = PRODUCT_HANDLE_MAP[productId];
  if (!handle) {
    console.error(`No Shopify handle found for product: ${productId}`);
    return null;
  }

  const API_URL = getStorefrontApiUrl();
  const headers = getStorefrontHeaders();
  
  // Use exact same query format as working tests
  const query = `
    query {
      product(handle: "${handle}") {
        id
        handle
        title
        availableForSale
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
              availableForSale
              price {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `;

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({ query })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('HTTP Error:', errorText);
      return null;
    }

    const data = await response.json();

    if (data.errors) {
      console.error('GraphQL errors:', data.errors);
      return null;
    }

    if (data.data?.product) {
      const product = data.data.product;
      
      const result = {
        price: parseFloat(product.priceRange.minVariantPrice.amount),
        currencyCode: product.priceRange.minVariantPrice.currencyCode,
        variantId: product.variants.edges[0]?.node.id,
        available: product.availableForSale !== false // Default to true if undefined
      };
      
      return result;
    }

    return null;

  } catch (error) {
    console.error('❌ Fetch error:', error);
    return null;
  }
}

// Simple checkout function
export async function createCheckout(lineItems) {
  const mutation = `
    mutation createCheckout($lineItems: [CheckoutLineItemInput!]!) {
      checkoutCreate(input: {
        lineItems: $lineItems
      }) {
        checkout {
          id
          webUrl
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  try {
    const response = await fetch(getStorefrontApiUrl(), {
      method: 'POST',
      headers: getStorefrontHeaders(),
      body: JSON.stringify({
        query: mutation,
        variables: { lineItems }
      })
    });

    const data = await response.json();
    
    if (data.data?.checkoutCreate?.checkout) {
      return {
        checkoutId: data.data.checkoutCreate.checkout.id,
        checkoutUrl: data.data.checkoutCreate.checkout.webUrl
      };
    }
    
    throw new Error('Failed to create checkout');
  } catch (error) {
    console.error('Checkout error:', error);
    throw error;
  }
}